import { useEffect, useState } from "react";
import { reportCustomerMigrationOlt } from "../../api/customer";

export function useReportMigrationOLt({ filter }) {
  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getMigrationCustomers = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await reportCustomerMigrationOlt(filter);
      setCustomers(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getMigrationCustomers(filter);
  }, [filter]);

  return {
    customers,
    meta,
    loading,
    errorMsg,
    getMigrationCustomers,
  };
}
